const { default: Swiper } = require('swiper');
import { Thumbs, Navigation, EffectFade } from 'swiper/modules';

const galleries = document.querySelectorAll('.wc-product-gallery');
const galleryLightbox = document.querySelector('[js-product-gallery-lightbox]');
const htmlElement = document.documentElement;
const showClass = '-show';
const blockScrollClass = 'block-scroll';

if (galleries.length) {
    const galleryMainSwipers = new WeakMap();
    let lightboxMainSwiper = null;
    let activeGalleryMainSwiper = null;

    const goToGallerySlide = (swiper, oneBasedIndex) => {
        if (!swiper) return;
        const totalSlides = swiper.slides?.length || 0;
        if (!totalSlides) return;

        const parsed = parseInt(oneBasedIndex, 10);
        if (!Number.isFinite(parsed) || parsed < 1) return;
        if (parsed > totalSlides) return;

        const targetIndex = parsed - 1;
        swiper.slideTo(targetIndex);
    };

    const initGallerySwiper = (gallery) => {
        const mainEl = gallery.querySelector('.js-product-gallery-main');
        const thumbsEl = gallery.querySelector('.js-product-gallery-thumbs');
        if (!mainEl || !thumbsEl) return null;

        const thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 24,
            slidesPerView: 4,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                0: {
                    slidesPerView: 2.8,
                    spaceBetween: 12,
                },
                991.98: {
                    slidesPerView: 4,
                    spaceBetween: 12,
                },
            }
        });

        return new Swiper(mainEl, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: thumbsEl.querySelector('.js-thumb-nav-next'),
                prevEl: thumbsEl.querySelector('.js-thumb-nav-prev'),
            },
            thumbs: {
                swiper: thumbsSwiper
            }
        });
    };

    const openLightbox = (mainSwiper) => {
        if (!galleryLightbox || !lightboxMainSwiper || !mainSwiper) return;
        activeGalleryMainSwiper = mainSwiper;
        lightboxMainSwiper.slideTo(mainSwiper.activeIndex, 0);
        galleryLightbox.classList.add(showClass);
        htmlElement.classList.add(blockScrollClass);
    };

    const closeLightbox = () => {
        if (!galleryLightbox) return;
        galleryLightbox.classList.remove(showClass);
        htmlElement.classList.remove(blockScrollClass);

        if (activeGalleryMainSwiper && lightboxMainSwiper) {
            activeGalleryMainSwiper.slideTo(lightboxMainSwiper.activeIndex);
        }
    };

    Swiper.use([Thumbs, Navigation, EffectFade]);

    galleries.forEach(gallery => {
        const mainSwiper = initGallerySwiper(gallery);
        if (!mainSwiper) return;

        galleryMainSwipers.set(gallery, mainSwiper);

        const openLightboxButtons = gallery.querySelectorAll('.js-open-product-gallery-lightbox');
        if (openLightboxButtons.length) {
            openLightboxButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    openLightbox(mainSwiper);
                });
            });
        }
    });

    document.addEventListener('mda_configurator_gallery_slide', (event) => {
        const index = event?.detail?.index;
        galleries.forEach((gallery) => {
            goToGallerySlide(galleryMainSwipers.get(gallery), index);
        });

        goToGallerySlide(lightboxMainSwiper, index);
    });

    if (window.wcConfigurator && typeof window.wcConfigurator.syncGalleryToSelected === 'function') {
        window.wcConfigurator.syncGalleryToSelected();
    }

    if (galleryLightbox) {
        lightboxMainSwiper = initGallerySwiper(galleryLightbox);

        const closeButtons = galleryLightbox.querySelectorAll('[js-close-product-gallery-lightbox]');
        closeButtons.forEach((button) => {
            button.addEventListener('click', closeLightbox);
        });

        galleryLightbox.addEventListener('click', (event) => {
            if (event.target === galleryLightbox) {
                closeLightbox();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && galleryLightbox.classList.contains(showClass)) {
                closeLightbox();
            }
        });
    }
}
